var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { getRGBColor } from 'utils/layout';
import Notification from './Notification.js';
export const PromotionNotification = (_a) => {
    var _b;
    var { saveCSSVarColorsWithotPrefix, design, content, promotion, extraParams, onApply, onButtonClick } = _a, rest = __rest(_a, ["saveCSSVarColorsWithotPrefix", "design", "content", "promotion", "extraParams", "onApply", "onButtonClick"]);
    const { useTailwindPrefix, className, children } = rest;
    function mod_getRGBColor(hex, name) {
        if (saveCSSVarColorsWithotPrefix) {
            return getRGBColor(hex, name, '');
        }
        return getRGBColor(hex, name);
    }
    function getStyleOptions() {
        const values = [];
        const bg = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BACKGROUND');
        values.push(mod_getRGBColor((bg === null || bg === void 0 ? void 0 : bg.backgroundColor) || '#ffffff', 'alerts-notification-background'));
        const text = design === null || design === void 0 ? void 0 : design.textStyle.find((s) => s.type === 'BODY');
        values.push(mod_getRGBColor((text === null || text === void 0 ? void 0 : text.color) || '#565a5c', 'alerts-notification-a11y'));
        return values;
    }
    function getPosition() {
        switch (design === null || design === void 0 ? void 0 : design.displayPositionType) {
            case 'TOP_LEFT':
                return 'top-left';
            case 'TOP_RIGHT':
                return 'top-right';
            case 'BOTTOM_LEFT':
                return 'bottom-left';
            case 'BOTTOM_RIGHT':
                return 'bottom-right';
            default:
                return undefined;
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `:root {
               ${(_b = getStyleOptions()) === null || _b === void 0 ? void 0 : _b.join(' ')}
            }` }), _jsxs(Notification, Object.assign({}, rest, { position: getPosition() }, ((content === null || content === void 0 ? void 0 : content.buttonUrl)
                ? (() => {
                    const url = (() => {
                        const extraQs = new URLSearchParams(extraParams !== null && extraParams !== void 0 ? extraParams : {}).toString();
                        if (!extraQs)
                            return content.buttonUrl;
                        return `${content.buttonUrl}${content.buttonUrl.includes('?') ? '&' : '?'}${extraQs}`;
                    })();
                    return onButtonClick
                        ? {
                            onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                yield onButtonClick();
                                window.open(url, '_blank', 'noopener,noreferrer');
                            }),
                        }
                        : { linkUrl: url };
                })()
                : promotion && promotion.code
                    ? {
                        onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            yield (onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick());
                            onApply(promotion, extraParams !== null && extraParams !== void 0 ? extraParams : {});
                        }),
                    }
                    : {}), { className: classNames(className, {
                    'bg-alerts-notification-background text-alerts-notification-a11y': !useTailwindPrefix,
                    'tw-bg-alerts-notification-background tw-text-alerts-notification-a11y': useTailwindPrefix,
                }), buttonClassName: classNames({
                    'text-alerts-notification-a11y/50 hover:text-alerts-notification-a11y hover:bg-white/10': !useTailwindPrefix,
                    'tw-text-alerts-notification-a11y/50 hover:tw-text-alerts-notification-a11y hover:tw-bg-white/10': useTailwindPrefix,
                }) }, { children: [(content === null || content === void 0 ? void 0 : content.title) && (_jsx("h2", Object.assign({ className: classNames({
                            'font-bold mb-1': !useTailwindPrefix,
                            'tw-font-bold tw-mb-1': useTailwindPrefix,
                        }) }, { children: content.title }))), (content === null || content === void 0 ? void 0 : content.description) && _jsx("div", { dangerouslySetInnerHTML: { __html: content.description } }), children] }))] }));
};
export default PromotionNotification;
